module.exports = __webpack_public_path__ + "media/error.cb2d09c5.mp3";